//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SwiperMixin from '~/mixins/swiper.mixin.js';

export default {
  mixins: [SwiperMixin],
  props: {
    partners: {
      type: Array,
      required: true,
    },
  },
  mounted() {
    this.initSwiper();
  },
};
